export const roundTwoDecimals = (value: number): number => Math.round(value * 100) / 100;

/** Keeps a value within [min, max]; when min > max the result is max. */
export const clampNumber = (value: number, min: number, max: number): number => Math.min(Math.max(value, min), max);

const DEFAULT_PAGE_SIZE = 25;
export const MAX_PAGE_SIZE = 100;

/** Normalizes a page size to a safe positive integer within [1, MAX_PAGE_SIZE] (defaults to DEFAULT_PAGE_SIZE). */
export const toSafeLimit = (value: number, maxPageSize: number = MAX_PAGE_SIZE): number => {
  if (!Number.isFinite(value) || value <= 0) return DEFAULT_PAGE_SIZE;
  return Math.min(value, maxPageSize);
};

/** Normalizes a 1-based page number to a safe positive integer (defaults to 1). */
export const toSafePage = (value: number): number => {
  if (!Number.isFinite(value) || value < 1) return 1;
  return Math.floor(value);
};
